import { useTenant } from '../../../../contexts/TenantContext';

/**
 * The sports being contested, their format and where they are played.
 *
 * Content comes from the tenant's `league_sports` setting.
 */
const LeagueSports = () => {
  const { siteSettings } = useTenant();
  const sports = Array.isArray(siteSettings?.league_sports) ? siteSettings.league_sports : [];

  const outdoor = sports.filter((s) => s.setting === 'outdoor');
  const indoor = sports.filter((s) => s.setting !== 'outdoor');

  const renderGroup = (title, blurb, list) => {
    if (list.length === 0) return null;
    return (
      <div style={{ marginBottom: 34 }}>
        <h2 style={groupTitle}>{title}</h2>
        <p style={{ color: '#5c6b7f', marginBottom: 16 }}>{blurb}</p>
        <div style={grid}>
          {list.map((s) => (
            <div key={s.name} style={card}>
              <h3 style={cardTitle}>{s.name}</h3>
              {s.format && <p style={cardMeta}>{s.format}</p>}
              <dl style={{ margin: 0 }}>
                {s.categories && <Row label="Categories" value={s.categories} />}
                {s.venue && <Row label="Venue" value={s.venue} />}
                {s.dates && <Row label="Dates" value={s.dates} />}
                {s.entries != null && (
                  <Row label="Entries" value={Number(s.entries).toLocaleString('en-IN')} />
                )}
              </dl>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <section className="tb-page-section">
      <div className="tb-container">
        <div className="tb-page-banner">
          <img
            src={siteSettings?.page_banners?.sports || '/theme/assets/images/banner-2.jpg'}
            alt="Sports"
          />
        </div>

        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">Sports</h1>
          </div>

          {sports.length === 0 ? (
            <p>Sport details will be published shortly.</p>
          ) : (
            <>
              {renderGroup(
                'Outdoor',
                'Played at external venues on weekends, 9:00 AM to 6:00 PM.',
                outdoor
              )}
              {renderGroup(
                'Indoor',
                'Played in-office on weekdays, 11:00 AM to 9:00 PM, one sport per day.',
                indoor
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', gap: 10, padding: '5px 0', fontSize: 13.5 }}>
    <dt style={{ minWidth: 88, color: '#5c6b7f', margin: 0 }}>{label}</dt>
    <dd style={{ margin: 0, fontWeight: 600, color: '#22303f' }}>{value}</dd>
  </div>
);

const groupTitle = {
  fontSize: 20,
  margin: '0 0 4px',
  paddingBottom: 6,
  borderBottom: '2px solid #d8dee6',
};

const grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
  gap: 14,
};

const card = {
  border: '1px solid #e0e6ed',
  borderRadius: 8,
  padding: '16px 18px',
  background: '#fff',
};

const cardTitle = { margin: '0 0 3px', fontSize: 17 };
const cardMeta = { margin: '0 0 10px', fontSize: 12.5, color: '#8b7015', fontWeight: 600 };

export default LeagueSports;
